/*
 * @Author: wangyunwon
 * @Date: 2025-11-05 21:55:10
 * @Description: BR相关的常量
 */
import VueI18n from '@/i18n/locale'
import { i18n } from '@/common/utils/i18n'
import { BIZ_STATUS_OPTIONS } from '@/consts'
import { SIGN_PARTY_TYPE_LIST } from '@/config/sign/enums'

export const SHOP_FOLLOWUP_FILTER_OPTIONS = [
  {
    label: VueI18n.t('Gattaran_status_AuAL_dKPA' /** 待拜访 */),
    value: '10',
  },

  {
    label: VueI18n.t('Gattaran_status_nmHO_eiGS' /** 待攻克 */),
    value: '20',
  },

  {
    label: VueI18n.t('Gattaran_status_ojzr_GNwA' /** 待签约 */),
    value: '30',
  },

  {
    label: VueI18n.t('Gattaran_status_pAhA_kENZ' /** 待审核 */),
    value: '40',
  },

  {
    label: VueI18n.t('Gattaran_status_Ozec_ScYy' /** 待修改 */),
    value: '50',
  },

  {
    label: VueI18n.t('Gattaran_status_NNzP_nKcZ' /** 待完成开店检查项 */),
    value: '60',
  },

  {
    label: VueI18n.t('Gattaran_status_Gnih_zZzX' /** 已完成开店检查项 */),
    value: '70',
  },
]

//  拜访地图页筛选项
export const VISIT_MAP_FILTER_OPITIONS = [
  {
    label: VueI18n.t('Gattaran_status_jQaO_nxvn' /** 跟进状态 */),
    key: 'followUpStatus',
    col: 2,
    options: [],
  },
  {
    label: i18n.gettext('经营状态'),
    key: 'bizStatus',
    col: 1,
    options: BIZ_STATUS_OPTIONS,
  },
  {
    label: VueI18n.t('FoodB_Commision_Type_of_EIWZ' /** 商户类型 */),
    key: 'type',
    col: 3,
    options: SIGN_PARTY_TYPE_LIST,
  },
  {
    label: VueI18n.t('Gattaran_V20__eJGq' /** 商机等级 */),
    key: 'potential',
    col: 3,
    options: [],
  },
  {
    label: VueI18n.t('Gattaran_opt_aDBh_QgeX' /** 开店检查项 (RTBO) */),
    key: 'openCheck',
    multiple: false,
    col: 2,
    options: [],
  },
  {
    label: VueI18n.t('Gattaran_selection_TfHc_eCVN' /** 未完成的上线检查项 */),
    key: 'openCheckInfo',
    col: 2,
    options: [],
  },
  {
    label: VueI18n.t('FoodB_SimbaSignup0331_qKdR_ELgg' /** 商机来源 */),
    key: 'source',
    col: 2,
    options: [],
  },
  {
    label: VueI18n.t('FoodB_opencheck_UtkB_sIJi' /** 是否完成二次检查 */),
    key: 'bdOpenCheckStatus',
    multiple: false,
    col: 2,
    options: [],
  },
]

export const VISIT_MAP_SORT_OPTIONS = [
  {
    value: 0,
    label: `${VueI18n.t('FoodB_202207_Default_BQmA' /** 默认 */)} (${VueI18n.t(
      'Gattaran_Page_Distance_jPzG' /** 距离 */,
    )})`,
  },
  {
    value: 4,
    label: `${VueI18n.t('FoodB_0830__wEQD' /** 本月完单量 */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */,
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`,
  },
  {
    value: 3,
    label: `${VueI18n.t('FoodB_0830__wEQD' /** 本月完单量 */)} (${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */,
    )}→${VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */)})`,
  },
  {
    value: 6,
    label: `${VueI18n.t('FoodB_P0_cNyW_HkyE' /** 完单变化量 */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */,
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`,
  },
  {
    value: 5,
    label: `${VueI18n.t('FoodB_P0_cNyW_HkyE' /** 完单变化量 */)} (${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */,
    )}→${VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */)})`,
  },
  {
    value: 11,
    label: `${VueI18n.t('FoodB_process_ziFN_pEHW' /** 截止昨天RTBO完成进度  */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */,
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`,
  },
  {
    value: 16,
    label: `${VueI18n.t('FoodB_score_lThf_wlQT' /** 截止昨天RTBO完成进度  */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */,
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`,
  },
  {
    value: 17,
    label: `${VueI18n.t('FoodB_score_lThf_wlQT' /** 截止昨天RTBO完成进度  */)} (${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */,
    )}→${VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */)})`,
  },
]
